import { FAQAdapter } from '@/Module/Question/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const { selectAll: faqSelectAll } = FAQAdapter.getSelectors<IState>(state => state.faq);
